if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        mainSwiper: this.querySelector('.product-main-swiper'),
        thumbnailSwiper: this.querySelector('.product-thumbnail-swiper')
      }
      
      this.mql = window.matchMedia('(min-width: 750px)');
      this.userHasInteracted = false; // ユーザーのインタラクション追跡
      
      this.initSwipers();
      this.bindEvents();
    }

    initSwipers() {
      // メインスライダーの初期化
      if (this.elements.mainSwiper) {
        this.mainSwiper = new Swiper(this.elements.mainSwiper, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          autoHeight: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            formatFractionCurrent: function (number) {
              return number;
            },
            formatFractionTotal: function (number) {
              return number;
            },
            renderFraction: function (currentClass, totalClass) {
              return '<span class="' + currentClass + '"></span>' +
                     ' / ' +
                     '<span class="' + totalClass + '"></span>';
            }
          },
          on: {
            slideChange: (swiper) => {
              this.onMainSlideChange(swiper);
            },
            init: (swiper) => {
              this.adjustPaginationPosition(swiper);
            },
            resize: (swiper) => {
              this.adjustPaginationPosition(swiper);
            }
          }
        });
      }

      // サムネイルスライダーの初期化
      if (this.elements.thumbnailSwiper) {
        this.thumbnailSwiper = new Swiper(this.elements.thumbnailSwiper, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            320: {
              slidesPerView: 4,
              spaceBetween: 8
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 10
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 15
            }
          }
        });
      }
    }

    bindEvents() {
      // サムネイルクリックイベント
      if (this.elements.thumbnailSwiper) {
        this.elements.thumbnailSwiper.querySelectorAll('.thumbnail-slide').forEach((slide, index) => {
          slide.addEventListener('click', () => {
            this.userHasInteracted = true; // ユーザーインタラクションを記録
            this.goToSlide(index);
          });
        });
      }

      // ナビゲーションボタンのクリックイベント
      if (this.elements.mainSwiper) {
        const nextButton = this.elements.mainSwiper.querySelector('.swiper-button-next');
        const prevButton = this.elements.mainSwiper.querySelector('.swiper-button-prev');
        
        if (nextButton) {
          nextButton.addEventListener('click', () => {
            this.userHasInteracted = true;
          });
        }
        
        if (prevButton) {
          prevButton.addEventListener('click', () => {
            this.userHasInteracted = true;
          });
        }
      }

      // ページ全体でのユーザーインタラクションを監視
      document.addEventListener('click', () => {
        this.userHasInteracted = true;
      }, { once: true });

      document.addEventListener('touchstart', () => {
        this.userHasInteracted = true;
      }, { once: true });

      // リサイズイベントの監視
      window.addEventListener('resize', () => {
        if (this.mainSwiper) {
          this.adjustPaginationPosition(this.mainSwiper);
        }
      });
    }

    adjustPaginationPosition(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const mediaContainer = activeSlide.querySelector('.product-media-container');
      const pagination = swiper.pagination.el;
      
      if (mediaContainer && pagination) {
        // product-media-containerの高さを取得
        const containerHeight = mediaContainer.offsetHeight;
        
        // ページネーションをproduct-media-containerの下から20pxの位置に設定
        pagination.style.position = 'absolute';
        pagination.style.left = '50%';
        pagination.style.transform = 'translate(-50%)';
        pagination.style.zIndex = '10';
        
        // img-altがある場合の調整
        const imgAlt = activeSlide.querySelector('.img-alt');
        
        // 画面幅に応じてbottomの値を調整
        if (window.innerWidth >= 768) {
          // 768px以上の場合
          if (imgAlt) {
            pagination.style.bottom = '42px';
          } else {
            pagination.style.bottom = '20px';
          }
        } else {
          // 768px未満の場合
          if (imgAlt) {
            pagination.style.bottom = '32px';
          } else {
            pagination.style.bottom = '10px';
          }
        }
      }
    }

    onMainSlideChange(swiper) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const mediaId = activeSlide.dataset.mediaId;
      
      // サムネイルのアクティブ状態を更新
      this.setActiveThumbnail(mediaId);
      
      // メディアの再生（動画の自動再生を有効化）
      this.playActiveMedia(activeSlide);
      
      // アクセシビリティの更新
      this.announceLiveRegion(activeSlide, swiper.activeIndex + 1);
      
      // ページネーションの位置を調整
      this.adjustPaginationPosition(swiper);
    }

    setActiveThumbnail(mediaId) {
      if (!this.elements.thumbnailSwiper) return;

      // すべてのサムネイルからアクティブ状態を削除
      this.elements.thumbnailSwiper.querySelectorAll('.thumbnail-slide').forEach(slide => {
        slide.classList.remove('swiper-slide-thumb-active');
        const button = slide.querySelector('button');
        if (button) button.removeAttribute('aria-current');
      });

      // 対応するサムネイルをアクティブにする
      const targetThumbnail = this.elements.thumbnailSwiper.querySelector(`[data-target="${mediaId}"]`);
      if (targetThumbnail) {
        targetThumbnail.classList.add('swiper-slide-thumb-active');
        const button = targetThumbnail.querySelector('button');
        if (button) button.setAttribute('aria-current', 'true');
        
        // サムネイルスライダーでアクティブなサムネイルを表示
        const thumbnailIndex = Array.from(this.elements.thumbnailSwiper.querySelectorAll('.thumbnail-slide')).indexOf(targetThumbnail);
        this.thumbnailSwiper.slideTo(thumbnailIndex);
      }
    }

    goToSlide(index) {
      if (this.mainSwiper) {
        this.mainSwiper.slideTo(index);
      }
    }

    setActiveMedia(mediaId, prepend) {
      if (!this.mainSwiper) return;

      const slides = this.mainSwiper.slides;
      const targetIndex = Array.from(slides).findIndex(slide => slide.dataset.mediaId === mediaId);
      
      if (targetIndex !== -1) {
        this.mainSwiper.slideTo(targetIndex);
      }

      this.preventStickyHeader();
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      // 動画の自動再生機能を実装
      const deferredMedia = activeItem.querySelector('deferred-media');
      if (deferredMedia) {
        // 既存の動画を停止
        this.stopAllVideos();
        
        // ユーザーがインタラクションした場合のみ自動再生
        if (this.userHasInteracted) {
          const posterButton = deferredMedia.querySelector('.deferred-media__poster');
          if (posterButton) {
            // 少し遅延を入れてから再生（スライド切り替えのアニメーション完了後）
            setTimeout(() => {
              posterButton.click();
              
              // 動画が表示されるまで待ってから再生
              setTimeout(() => {
                const video = deferredMedia.querySelector('video');
                console.log('video', video);
                if (video) {
                  video.play();
                }
              }, 100); // 動画表示を待つ
            }, 300);
          }
        }
      }
    }

    stopAllVideos() {
      // すべての動画を停止
      this.querySelectorAll('deferred-media').forEach(deferredMedia => {
        const video = deferredMedia.querySelector('video, iframe');
        if (video) {
          if (video.tagName === 'VIDEO') {
            video.pause();
            video.currentTime = 0;
          } else if (video.tagName === 'IFRAME') {
            // YouTube/Vimeoの場合は、srcを変更して停止
            const currentSrc = video.src;
            if (currentSrc.includes('youtube') || currentSrc.includes('vimeo')) {
              video.src = '';
              video.src = currentSrc;
            }
          }
        }
      });
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
  });
}
